import { Checkbox, TableCell, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateAlertAction } from "redux/reducers/alertsReducer";
import { AppColors } from "resources/AppColors";
import { formatDateWithHourAndMinute } from "utils/HelperFunctions";

export function AlertsTableRows({ alert }) {
  const [enabled, setEnabled] = useState(alert.viewed);

  const dispatch = useDispatch()

  const handleEnabled = (event) => {
    dispatch(updateAlertAction({ id: alert.id, viewed: event.target.checked }))
    setEnabled(event.target.checked);
  };

  return (
    <>
      <TableCell align="left">
        <Typography variant='body'>{alert.message || '-'}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{alert.fullName || '-'}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{formatDateWithHourAndMinute(alert.creationDate)}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body_bold'>
          <Checkbox
            checked={enabled}
            onChange={handleEnabled}
            style={{ color: AppColors.PRIMARY }}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </Typography>
      </TableCell>
    </>
  )
}